/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const AssignPurchaseTaskCreate = lazyLoad(
  () => import('./index'),
  module => module.AssignPurchaseTaskCreate
);
